import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d111f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-info-row" }
const _hoisted_2 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_3 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_8 = { class: "account-info-row" }
const _hoisted_9 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_10 = {
  key: 1,
  class: "error-msg"
}
const _hoisted_11 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_12 = {
  key: 1,
  class: "error-msg"
}
const _hoisted_13 = { class: "account-info-row" }
const _hoisted_14 = ["type", "required"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 17" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-form-eye" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L19 19",
    stroke: "black",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_19 = ["type", "required"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 17" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-form-eye" })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L19 19",
    stroke: "black",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_24 = ["type", "required"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 17" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-form-eye" })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L19 19",
    stroke: "black",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_29 = { class: "account-info-foot" }
const _hoisted_30 = {
  key: 0,
  class: "error-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonSave = _resolveComponent("ButtonSave")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!
  const _component_LeavePopin = _resolveComponent("LeavePopin")!

  return (_openBlock(), _createElementBlock("form", {
    class: "account-info form",
    onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
    novalidate: "",
    autocomplete: "off"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.first-name')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstname) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.form.firstname.$touch && _ctx.v$.form.firstname.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.form.firstname.$errors.length }),
          type: "text",
          name: "firstname",
          minlength: "2",
          required: "",
          spellcheck: "false",
          autocorrect: "off",
          autocomplete: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.form.firstname,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$.form.firstname.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.v$.form.firstname.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.last-name')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.lastname) = $event)),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.form.lastname.$touch && _ctx.v$.form.lastname.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.form.lastname.$errors.length }),
          type: "text",
          name: "lastname",
          minlength: "2",
          required: "",
          spellcheck: "false",
          autocorrect: "off",
          autocomplete: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.form.lastname,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$.form.lastname.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.v$.form.lastname.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.email')), 1),
        _withDirectives(_createElementVNode("input", {
          readonly: "",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.email) = $event)),
          type: "email",
          name: "email"
        }, null, 512), [
          [_vModelText, _ctx.form.email]
        ])
      ]),
      (_ctx.allowLang)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_4, [
            _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.lang')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.preferredLang) = $event)),
              onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$?.form.lang.$touch && _ctx.v$?.form.lang.$touch(...args))),
              class: _normalizeClass({ 'error': _ctx.v$?.form.lang.$errors.length }),
              name: "country"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, (lang) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: lang.slug,
                  value: lang.slug
                }, _toDisplayString(lang.name), 9, _hoisted_5))
              }), 128))
            ], 34), [
              [_vModelSelect, _ctx.form.preferredLang]
            ]),
            _hoisted_6,
            (_ctx.v$?.form.lang.$errors.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.v$?.lang?.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('account.change_email')), 1),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('account.new_email')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.new_email) = $event)),
          onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.form.new_email.$touch && _ctx.v$.form.new_email.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.isAlreadyExist || _ctx.v$.form.new_email.$errors.length }),
          type: "email",
          name: "email",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off",
          autocomplete: "off"
        }, null, 34), [
          [_vModelText, _ctx.form.new_email]
        ]),
        (_ctx.v$.form.new_email.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.v$.form.new_email.$errors[0].$message), 1))
          : _createCommentVNode("", true),
        (_ctx.isAlreadyExist)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.errorEmail), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('account.confirm_new_email')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.confirm_new_email) = $event)),
          onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.form.confirm_new_email.$touch && _ctx.v$.form.confirm_new_email.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.isAlreadyExist || _ctx.v$.form.confirm_new_email.$errors.length }),
          type: "email",
          name: "email",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off",
          autocomplete: "off"
        }, null, 34), [
          [_vModelText, _ctx.form.confirm_new_email]
        ]),
        (_ctx.v$.form.confirm_new_email.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.v$.form.confirm_new_email.$errors[0].$message), 1))
          : _createCommentVNode("", true),
        (_ctx.isAlreadyExist)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.errorEmail), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('account.change_password')), 1),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('account.current_password')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.current_password) = $event)),
          onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.form.current_password.$touch && _ctx.v$.form.current_password.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.form.current_password.$errors.length }),
          type: _ctx.isPasswordObscurated ? 'password' : 'text',
          name: "current_password",
          minlength: "8",
          required: _ctx.form.current_password !== '' || _ctx.form.new_password !== '' || _ctx.form.confirm_new_password !== '',
          autocomplete: "off",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 42, _hoisted_14), [
          [_vModelDynamic, _ctx.form.current_password]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass([{ 'active': _ctx.isPasswordObscurated }, "form__hide"]),
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isPasswordObscurated = !_ctx.isPasswordObscurated)),
          tabindex: "-1"
        }, _hoisted_17, 2),
        (_ctx.v$.form.current_password.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.v$.form.current_password.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('account.new_password')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.new_password) = $event)),
          onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.form.new_password.$touch && _ctx.v$.form.new_password.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.form.new_password.$errors.length }),
          type: _ctx.isPasswordObscurated ? 'password' : 'text',
          name: "new_password",
          minlength: "8",
          required: _ctx.form.current_password !== '' || _ctx.form.new_password !== '' || _ctx.form.confirm_new_password !== '',
          autocomplete: "off",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 42, _hoisted_19), [
          [_vModelDynamic, _ctx.form.new_password]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass([{ 'active': _ctx.isPasswordObscurated }, "form__hide"]),
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isPasswordObscurated = !_ctx.isPasswordObscurated)),
          tabindex: "-1"
        }, _hoisted_22, 2),
        (_ctx.v$.form.new_password.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.v$.form.new_password.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('account.confirm_new_password')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.confirm_new_password) = $event)),
          onBlur: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.v$.form.confirm_new_password.$touch && _ctx.v$.form.confirm_new_password.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.form.confirm_new_password.$errors.length }),
          type: _ctx.isPasswordObscurated ? 'password' : 'text',
          name: "confirm_new_password",
          minlength: "8",
          required: _ctx.form.current_password !== '' || _ctx.form.new_password !== '' || _ctx.form.confirm_new_password !== '',
          autocomplete: "off",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 42, _hoisted_24), [
          [_vModelDynamic, _ctx.form.confirm_new_password]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass([{ 'active': _ctx.isPasswordObscurated }, "form__hide"]),
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isPasswordObscurated = !_ctx.isPasswordObscurated)),
          tabindex: "-1"
        }, _hoisted_27, 2),
        (_ctx.v$.form.confirm_new_password.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.v$.form.confirm_new_password.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_ButtonSave, {
        saved: _ctx.saved,
        loading: _ctx.isLoading,
        type: "submit",
        class: "button"
      }, {
        saved: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('account.saved')), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('account.save')) + " ", 1)
        ]),
        _: 1
      }, 8, ["saved", "loading"]),
      (_ctx.errorMessage !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"]),
    _createVNode(_component_LeavePopin, {
      title: _ctx.$t('profileEdit.leaveTitle'),
      text: _ctx.$t('profileEdit.leaveText'),
      labelAccept: _ctx.$t('profileEdit.leaveAccept'),
      labelDecline: _ctx.$t('profileEdit.leaveDecline'),
      active: _ctx.showLeavePopin,
      onOnAccept: _ctx.onLeaveAccept,
      onOnDecline: _ctx.onLeaveDecline
    }, null, 8, ["title", "text", "labelAccept", "labelDecline", "active", "onOnAccept", "onOnDecline"])
  ], 32))
}